import { Component } from '@angular/core';
import { PriceListsPortalComponent } from '../pricelists-portal/pricelists-portal.component';

@Component({
  standalone: true,
  imports: [PriceListsPortalComponent],
  selector: 'lx-price-lists-portal-eu-price-lists-portal',
  templateUrl: './eu-pricelists-portal.component.html',
  styleUrls: ['./eu-pricelists-portal.component.scss'],
})
export class EuPriceListsPortalComponent {}
